import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { GlobalDialogReference } from './global/dialog-manager/dialog';
import { AppInfo } from './global/environment';
import { FeatureFlags } from './global/featureFlags/featureFlags';
import { PostCode } from './global/postcode';
import { Tracking } from './global/tracking/tracking';
import { DialogService } from './shared/components/dialog/services/dialog.service';
import { handleTitleOnRouteEvents } from './shared/routing/routing-utils';
import { BrowserSharedService } from './shared/services/browser-shared.service';
import { UserService } from './shared/services/user.service';

declare global {
  interface Window {
    dataLayer: any[];
    OneTrust: any;
    _genesys: any;
    Genesys: any;
  }
}

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly dialogService: DialogService,
    private readonly userService: UserService,
    private http: HttpClient,
    readonly browserSharedService: BrowserSharedService
  ) {
    this.initialiseCookiePro();
  }

  ngOnInit() {
    this.userService.loadUser();
    handleTitleOnRouteEvents(this.router, this.route);
    this.initialiseThirdPartyApps();
  }

  initialiseCookiePro(): void {
    const { autoBlockScript, src, domainScript } = AppInfo.Environment.cookiePro;

    const autoBlockScriptTag = document.createElement('script');
    autoBlockScriptTag.type = 'text/javascript';
    autoBlockScriptTag.src = autoBlockScript;

    const cookieProTag = document.createElement('script');
    cookieProTag.type = 'text/javascript';
    cookieProTag.src = src;
    cookieProTag.setAttribute('charset', 'UTF-8');
    cookieProTag.setAttribute('data-domain-script', domainScript);

    document.head.insertBefore(autoBlockScriptTag, document.head.childNodes[0]);
    document.head.insertBefore(cookieProTag, document.head.childNodes[0]);
  }

  initialiseThirdPartyApps(): void {
    // TODO: Pass in used ID in this flow
    // LiveChat.initialise();
    Tracking.initialise();
    FeatureFlags.initialise();
    GlobalDialogReference.initialise(this.dialogService);
    PostCode.initialise(this.http);
  }
}
